// PrivateRoute — منقول من frontend/src/components/PrivateRoute.js: يتحقّق من صلاحيّة JWT
// المخزَّن (لا يثق بالحالة فقط) قبل السماح بالدخول لأي مسار خاصّ.
import { jwtDecode } from 'jwt-decode';
import { Navigate, Outlet } from 'react-router-dom';
import { clearAuthStorage, readStorage } from '../lib/storage';

interface DecodedToken {
	exp: number;
}

export default function PrivateRoute() {
	const token = readStorage('token');
	let isTokenValid = false;

	if (token) {
		try {
			const decoded = jwtDecode<DecodedToken>(token);
			if (decoded.exp * 1000 > Date.now()) {
				isTokenValid = true;
			} else {
				clearAuthStorage();
			}
		} catch {
			clearAuthStorage();
		}
	}

	return isTokenValid ? <Outlet /> : <Navigate to="/login" replace />;
}
